import { SITE } from "@api/constants";
import fetchUserState from "@api/operations/fetch-customer-state";
import { UserHelpRequestTable, CreateHelpRequestThread } from "@kcc/help-center";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { NextSeo } from "next-seo";
import Head from "next/head";
import React from "react";

import Container from "@components/Container";
import HelpCenterLoginRequired from "@components/HelpCenterLoginRequired";
import MainLayout from "@components/MainLayout";
import Spacer from "@components/Spacer";
import Title from "@components/Title";

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const {
    cookies: { token },
  } = req;
  // token may not exist yet if you have just accessed the site supply a mock customer in this case
  if (!token) {
    return {
      props: { customer: { guest: true } },
    };
  }

  const { customer } = await fetchUserState(token);

  return { props: { token, customer } };
};

type HelpCenterPageProps = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function HelpCenterPage({ token, customer }: HelpCenterPageProps) {
  const account = SITE;
  const themeColor = "rgb(255, 54, 0)";

  const criteria = [];
  criteria.push({ namespace: "helpThread", code: "accountId", value: account });

  return (
    <>
      <Head>
        <title>Help Center | Bobcat</title>
      </Head>
      <Spacer size={"md"} />
      <Container>
        <NextSeo title="Help Center | Bobcat" />
        <Title>Help Center</Title>
        <Spacer size={"sm"} />
        {customer.guest ? (
          <HelpCenterLoginRequired />
        ) : (
          <>
            <div style={{ textAlign: "center" }}>
              You can contact phone support at: <a href="tel:1-414-422-8008">1-414-422-8008</a>
            </div>
            <Spacer size={"sm"} />
            <CreateHelpRequestThread
              account={account}
              token={token}
              onCompleteRedirectPathname={`help-center/help-thread`}
              themeColor={themeColor}
              successMessage="Help request successfully submitted. Someone will respond to your request within the next business day."
              templateLabel="Select a topic"
            />
            <h1>Help Request Threads</h1>
            <UserHelpRequestTable token={token} criteria={criteria} themeColor={themeColor} />
          </>
        )}
      </Container>
    </>
  );
}

HelpCenterPage.Layout = MainLayout;
